import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles'; 
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
     theme.palette.mode === 'light'
            ? `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 50%, transparent 100%)`
            : `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.2)} 0%, ${alpha(theme.palette.secondary.dark, 0.2)} 50%, transparent 100%)`,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

export const CardStyle = styled('div')(({ theme, sx }) => ({
  boxShadow: theme.palette.mode === 'light' 
    ? `0px 1px 2px ${alpha(theme.palette.primary.main, 0.12)}` 
    : `0px 1px 2px ${alpha('#000000', 0.24)}`,
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  background: theme.palette.mode === 'light' 
    ? 'white' 
    : theme.palette.background.paper,
  border: `1px solid ${theme.palette.mode === 'light' 
    ? alpha(theme.palette.primary.main, 0.08) 
    : alpha(theme.palette.primary.light, 0.12)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  // '&:hover': {
  //   transform: 'translateY(-4px)',
  //   boxShadow: theme.palette.mode === 'light'
  //     ? `0px 1px 2px ${alpha(theme.palette.primary.main, 0.16)}`
  //     : `0px 1px 2px ${alpha('#000000', 0.32)}`,
  // },
  ...sx,
}));
export const GradientStyle = styled('div')(({ theme, sx }) => ({
  height: '100%',
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 50%, transparent 100%)`
    : `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.2)} 0%, ${alpha(theme.palette.secondary.dark, 0.2)} 50%, transparent 100%)`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.gradients?.brand || theme.palette.gradients?.primary,
    opacity: 0.05,
    pointerEvents: 'none',
  },
  ...sx,
}));
  

export const IconifyLink = styled('a')(({ theme }) => (
    {
        textDecoration: 'none',
        cursor: "pointer",
        color: theme.palette.primary.main,
    }
));

export const BlankLink = styled('a')(({ theme, selected }) => (
    {
        textDecoration: selected ? 'underline' : 'none',
        cursor: "pointer",
        color: selected ? theme.palette.primary.main : theme.palette.text.primary,
    }
));

export const BackgroundImageStyle = styled('div')(({ theme, sx }) => (
    {
        ...sx,
        display: 'flex',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }
));

export const ToggleButton = styled('div')(({ theme, selected }) => ({
  padding: '12px 0',
  textAlign: 'center',
  borderRadius: '8px',
  width: '100%',
  background: selected 
    ? theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`
    : theme.palette.mode === 'light' ? '#f8fafc' : theme.palette.grey[800],
  cursor: 'pointer',
  color: selected 
    ? 'white' 
    : theme.palette.text.primary,
  boxShadow: selected
    ? `0px 8px 24px ${alpha(theme.palette.primary.main, 0.24)}`
    : `0px 2px 8px ${alpha(theme.palette.grey[500], 0.12)}`,
  border: `1px solid ${selected 
    ? 'transparent' 
    : alpha(theme.palette.grey[500], 0.2)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fontWeight: selected ? 600 : 500,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: selected
      ? `0px 12px 32px ${alpha(theme.palette.primary.main, 0.32)}`
      : `0px 8px 16px ${alpha(theme.palette.grey[500], 0.16)}`,
  },
}));

export const SelectStyle = styled('select')(({ theme,sx}) => (
    {
        outline: 'none',
        border: '1px solid #E5E5E5',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '16px',
        fontWeight: 400,
        color: '#868686',
        ...sx,
    }
));

export const SearchBar = styled('div')(({ theme, sx }) => ({
  borderRadius: 12,
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  boxShadow: `0px 4px 16px ${alpha(theme.palette.primary.main, 0.08)}`,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:focus-within': {
    boxShadow: `0px 8px 24px ${alpha(theme.palette.primary.main, 0.16)}`,
    borderColor: theme.palette.primary.main,
  },
  '& input': {
    border: 'none',
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    background: 'transparent',
    color: theme.palette.text.primary,
    '&:focus, &:active': {
      outline: 'none',
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  '& button': {
    background: theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    border: 'none',
    padding: '12px 20px',
    color: 'white',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: `0px 4px 12px ${alpha(theme.palette.primary.main, 0.24)}`,
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  ...sx,
}));

export const RootStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
    : `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
  display: 'flex',
  flexDirection: 'column',
  gap: '4rem',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 30% 20%, ${alpha('#ffffff', 0.1)} 0%, transparent 50%)`,
    pointerEvents: 'none',
  },
  ...sx,
}));

export const TableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  color: theme.palette.text.primary,
  borderRadius: 12,
  overflow: 'hidden',
  boxShadow: `0px 8px 32px ${alpha(theme.palette.primary.main, 0.08)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    background: theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    fontWeight: 600,
    fontSize: 14,
    color: 'white',
    verticalAlign: 'bottom',
    padding: '1rem',
    textAlign: 'left',
  },
  '& tbody tr': {
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
      color: theme.palette.primary.main,
    },
  },
  '& tbody tr td': {
    background: theme.palette.background.paper,
    padding: '12px 16px',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.1)}`,
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: 14,
  },
  '& tbody tr td img': {
    height: 40,
    borderRadius: 8,
    verticalAlign: 'middle',
  },
  ...sx,
}));
export const NormalTableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  borderRadius: 12,
  overflow: 'hidden',
  background: alpha(theme.palette.background.paper, 0.9),
  boxShadow: `0px 4px 16px ${alpha(theme.palette.grey[500], 0.08)}`,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
    background: alpha(theme.palette.grey[100], 0.8),
    fontWeight: 600,
    fontSize: 14,
    verticalAlign: 'bottom',
    padding: '12px 16px',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  '& tbody tr': {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.02),
    },
  },
  '& tbody tr td': {
    padding: '10px 16px',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    verticalAlign: 'middle',
    fontSize: 13,
    color: theme.palette.text.primary,
  },
  '& tbody tr td:first-of-type, & thead tr th:first-of-type': {
    borderLeft: 'none',
  },
  '& tbody tr td img': {
    height: 40,
    borderRadius: 8,
    verticalAlign: 'middle',
  },
  ...sx,
}));
